"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarrageAbilityHandler = exports.BarrageActorAbilityFactory = exports.BarrageAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class BarrageAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Barrage;
        this.__typeName = "Barrage";
    }
}
exports.BarrageAbilityArgs = BarrageAbilityArgs;
let BarrageActorAbilityFactory = class BarrageActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Barrage", "AllEnemies", 1);
    }
};
BarrageActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Barrage")
], BarrageActorAbilityFactory);
exports.BarrageActorAbilityFactory = BarrageActorAbilityFactory;
let BarrageAbilityHandler = class BarrageAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyMultiAttack({
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            sequence,
            targets: enemies.map(targetId => ({
                targetId: targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 50)
                ]
            })),
            onHitOrMiss: (sequence, { targetId }, { hit }) => {
                sequence.push(new core_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet")
                    : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "GoldenArrowBarrage"));
            }
        });
    }
};
BarrageAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Barrage)
], BarrageAbilityHandler);
exports.BarrageAbilityHandler = BarrageAbilityHandler;
